import { Button, Flex, Form, Select, SimpleLayout, Text, useLayout } from '@approvalmax/ui/src/components';
import { Helmet } from 'react-helmet';

import { fieldNameCompanyName, fieldNameCompanySelectedId } from './resources/constants';
import { useReceiptBankCompanies } from './resources/hooks/useReceiptBankCompanies';
import { messages } from './resources/messages';

const Page = () => {
    useLayout({ containerMinSize: 'xxsmall' });

    const { form, companies, isLoading, onSubmit, onCancel } = useReceiptBankCompanies();

    const isNoCompanies = companies.length === 0;
    const isSingleCompany = companies.length === 1;
    const isMultipleCompanies = companies.length > 1;

    const companyName = form.watch(fieldNameCompanyName);
    const companySelectedId = form.watch(fieldNameCompanySelectedId);

    return (
        <SimpleLayout size='small'>
            <Helmet title={messages.pageTitle} />

            <SimpleLayout.Content>
                <Form form={form} onSubmit={onSubmit}>
                    <Flex container direction='column' spacing='24'>
                        <Text font='headline' fontSize='small' textAlign='center'>
                            {isNoCompanies && messages.titleNoCompanies}

                            {isSingleCompany && companyName && messages.titleSingleCompany({ companyName })}

                            {isMultipleCompanies && messages.titleMultipleCompanies}
                        </Text>

                        {isMultipleCompanies && (
                            <Select
                                name={fieldNameCompanySelectedId}
                                disabled={isLoading}
                                size='medium'
                                itemIdKey='id'
                                itemNameKey='displayName'
                                clearable={false}
                                items={companies}
                            />
                        )}

                        {(isSingleCompany || isMultipleCompanies) && (
                            <Flex size={24} block>
                                <Button
                                    type='submit'
                                    block
                                    size='large'
                                    color='green80'
                                    progress={isLoading}
                                    disabled={isLoading || !companySelectedId}
                                >
                                    {messages.buttonAllowAccess}
                                </Button>
                            </Flex>
                        )}

                        <Flex size={24} block>
                            <Button block size='large' color='midnight40' onClick={onCancel} disabled={isLoading}>
                                {messages.buttonCancel}
                            </Button>
                        </Flex>
                    </Flex>
                </Form>
            </SimpleLayout.Content>
        </SimpleLayout>
    );
};

export default Page;
